import { render, staticRenderFns } from "./Login_Auth_Pop_Up.vue?vue&type=template&id=202d641d&"
import script from "./Login_Auth_Pop_Up.vue?vue&type=script&lang=js&"
export * from "./Login_Auth_Pop_Up.vue?vue&type=script&lang=js&"
import style0 from "./Login_Auth_Pop_Up.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports